// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  popularAttractionRequest: ['data'],
  popularAttractionSuccess: ['data'],
  popularAttractionFailure: ['err'],

  popularAttractionSaveRequest: ['data'],
  popularAttractionSaveSuccess: ['data'],
  popularAttractionSaveFailure: ['err'],

  popularAttractionDeleteRequest: ['data'],
  popularAttractionDeleteSuccess: ['data'],
  popularAttractionDeleteFailure: ['err'],

  popularAttractionEditRequest: ['data'],
  popularAttractionEditSuccess: ['data'],
  popularAttractionEditFailure: ['err'],
})

export const PopularAttractionTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  processing: false,
  data: [],
  err: null,
  success: false,
})

/* ------------- Reducers ------------- */

export const request = (state: Object) =>
  state.merge({ fetching: true, err: null , success: false})

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    data,
    err: null,
  })

export const changeRequest = (state: Object) =>
  state.merge({ processing: true, err: null, success: false })

export const changeSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    processing: false,
    err: null,
    success: true
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.POPULAR_ATTRACTION_REQUEST]: request,
  [Types.POPULAR_ATTRACTION_SUCCESS]: success,
  [Types.POPULAR_ATTRACTION_FAILURE]: failure,

  [Types.POPULAR_ATTRACTION_SAVE_REQUEST]: changeRequest,
  [Types.POPULAR_ATTRACTION_SAVE_SUCCESS]: changeSuccess,
  [Types.POPULAR_ATTRACTION_SAVE_FAILURE]: failure,

  [Types.POPULAR_ATTRACTION_DELETE_REQUEST]: changeRequest,
  [Types.POPULAR_ATTRACTION_DELETE_SUCCESS]: changeSuccess,
  [Types.POPULAR_ATTRACTION_DELETE_FAILURE]: failure,

  [Types.POPULAR_ATTRACTION_EDIT_REQUEST]: changeRequest,
  [Types.POPULAR_ATTRACTION_EDIT_SUCCESS]: changeSuccess,
  [Types.POPULAR_ATTRACTION_EDIT_FAILURE]: failure,
})



// WEBPACK FOOTER //
// ./src/Redux/PopularAttractionRedux.js